import { createSlice } from '@reduxjs/toolkit';
import { createReportTemplateApi } from '../../../rtk-apis/reports/createTemplate';

const initialState = {
  status: '',
  data: '',
  msg: '',
  loading: false,
};

const createReportTemplateSlice = createSlice({
  name: 'createReportTemplateSlice',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.data = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(createReportTemplateApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(createReportTemplateApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.data = action?.payload?.data;
        state.msg = action?.payload?.msg;
      })
      .addCase(createReportTemplateApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.data = '';
        state.msg = (action?.payload as string) || 'Something went wrong!';
      });
  },
});

export default createReportTemplateSlice.reducer;
export const { clearState } = createReportTemplateSlice.actions;
